<template>
    <update-dialog
        :headerTitle="title"
        :showDialog="showDialog"
        :canUse="canUse"
        @close="showDialog = false"
        @confirm="confirm"
        @opened="$refs.elIpt.focus()">
        <el-input :placeholder="placeholder"
            :maxlength="maxLen"
            type="textarea"
            :rows="5"
            :show-word-limit="true"
            ref="elIpt"
            v-model="shopName"></el-input>
    </update-dialog>
</template>

<script>
import UpdateDialog from './update_dialog'
import { openMessage } from '@/utils/system.tsx'
import $fetch from '@/api'

export default {
    data() {
        return {
            showDialog: false,
            shopName: ''
        }
    },
    props: {
        title: {
            type: String,
            default: '修改店铺简介'
        },
        placeholder: {
            type: String,
            default: '请输入店铺简介'
        },
        maxLen: {
            type: Number,
            default: 100,
        }
    },
    computed: {
        canUse() {
            return this.shopName !== ''
        }
    },
    methods: {
        open(options = {}) {
            this.shopName = options.name || ''
            this.showDialog = true
        },

        confirm(cb) {
            return $fetch.post({
                url: '/shop/editshopinfo',
                params: {
                    description: this.shopName
                }
            }).then(data => {
                this.showDialog = false
                openMessage('success', '修改成功')
                this.$emit('refresh-shop-info')
            }, e => openMessage(0, e.message || '修改失败'))
            .then(() => cb())
        }
    },
    components: {
        UpdateDialog
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
    padding: 0 8px;
}
</style>
